<div
  class="history-item"
  [class.drop-shadow]="shadow()"
  [class.grey]="Grey"
  [class.red]="Red"
  [class.green]="Green"
  [class.yellow]="Yellow"
  [class.detailedHistory]="detailedhistory"
  [class.desktop]="isDesktop"
  [class.mobile]="isMobile"
  [class.tablet]="isTablet"
>
  <div class="history-content-wrapper">
    <div class="history-content-inner-wrapper">
      <div class="history-date">
        <span class="body-bold-cap history-time">
          {{ item()?.timestamp | date: DateFormat }}
        </span>
      </div>

      <div class="sub-item hasNote">
        <div class="sub-item-head">
          @if (Green) {
            <i
              nz-icon
              nzType="icons:circle"
              class="svg-icon mini-icon fillgreen circle-icon"
            ></i>
          }
          @if (Yellow) {
            <i
              nz-icon
              nzType="icons:status-exclamation-octagon"
              class="svg-icon mini-icon fillorange"
            ></i>
          }
          @if (Red) {
            <i
              nz-icon
              nzType="icons:status-exclamation-triangle"
              class="svg-icon mini-icon fillred"
            ></i>
          }
          @if (Grey) {
            <i
              nz-icon
              nzType="icons:cross-circle"
              class="svg-icon mini-icon fillblackcoral"
            ></i>
          }

          <span class="body-bold">{{ Message }}</span>
        </div>
      </div>
    </div>

    @if (Documentation && collapsible()) {
      <div
        class="history-right-icon-wrapper"
        role="button"
        tabindex="0"
        (click)="item() && (item()!.open = !item()!.open)"
        (keydown.enter)="item() && (item()!.open = !item()!.open)"
        (keydown.space)="item() && (item()!.open = !item()!.open)"
      >
        <i
          nz-icon
          [nzType]="item()?.open ? 'icons:minus' : 'icons:plus'"
          class="svg-icon mini-icon history-right-icon"
        ></i>
        @if (item()?.open && isDesktop) {
          <span class="detail-bold">{{ i18n.langString("hide_details") }}</span>
        }
        @if (!item()?.open && isDesktop) {
          <span class="detail-bold">{{ i18n.langString("show_details") }}</span>
        }
      </div>
    }
  </div>

  @if (Documentation && Open) {
    <div class="sub-item document-type">
      @switch (item()?.details?.documentationType) {
        @case ("repair") {
          <div class="sub-item-head">
            <i nz-icon nzType="icons:tool" class="svg-icon mini-icon"></i>
            <span class="body-bold">{{
              i18n.langString("needs_to_be_repaired")
            }}</span>
          </div>
        }
        @case ("fixed") {
          <div class="sub-item-head">
            <i nz-icon nzType="icons:fixed" class="svg-icon mini-icon"></i>
            <span class="body-bold">{{
              i18n.langString("problem_fixed")
            }}</span>
          </div>
        }
        @case ("false_alert") {
          <div class="sub-item-head">
            <i
              nz-icon
              nzType="icons:status-exclamation-triangle"
              class="svg-icon mini-icon"
            ></i>
            <span class="body-bold">{{ i18n.langString("false_alert") }}</span>
          </div>
        }
        @case ("other") {
          <div class="sub-item-head">
            <i nz-icon nzType="icons:others" class="svg-icon mini-icon"></i>
            <span class="body-bold">{{ i18n.langString("others") }}</span>
          </div>
        }
      }
    </div>
  }

  @if (Documentation && Open && item()?.details?.note) {
    <div class="sub-item note-item">
      <div class="sub-item-head">
        <i nz-icon nzType="icons:note" class="svg-icon mini-icon"></i>
        <span class="body-bold">{{ i18n.langString("note") }}</span>
      </div>
      <div class="sub-item-content note-content">
        <span class="regular">{{ item()?.details?.note }}</span>
      </div>
    </div>
  }

  @if (
    Documentation &&
    Open &&
    item() &&
    item()!.details &&
    item()!.details.photos &&
    item()!.details.photos.length > 0
  ) {
    <div class="sub-item photo-item">
      <!-- Photos -->
      <div class="sub-item-head">
        <i nz-icon nzType="icons:camera" class="svg-icon mini-icon"></i>
        <span class="body-bold">{{ i18n.langString("photos") }}</span>
      </div>

      <div class="photowrapper sub-item-content">
        @for (photo of item()?.details?.photos; track photo.picture) {
          <button
            class="photo-subwrapper"
            (click)="overlayImage = photo.picture"
            aria-label="View full image"
          >
            <img
              class="photo-preview"
              [src]="photo.thumbnail"
              (error)="onPhotoLoadingError(photo)"
              alt="thumbnail"
            />

            <div class="photo-icon-circle">
              <i nz-icon nzType="icons:filter" class="svg-icon mini-icon"></i>
              <span class="body-bold">{{ i18n.langString("show") }}</span>
            </div>
          </button>
        }
      </div>

      <nz-modal
        [(nzVisible)]="overlayImage"
        (nzOnCancel)="overlayImage = null"
        [nzFooter]="null"
        [nzTitle]="i18n.langString('photo')"
        [nzContent]="modalContent"
        [nzCloseIcon]="'icons:exit'"
      >
        <ng-template #modalContent>
          <img class="photo" [src]="overlayImage" alt="overlayImage" />
        </ng-template>
      </nz-modal>
    </div>
  }
  @if (Documentation && Open && item()?.details?.files?.length > 0) {
    <div class="sub-item file-item">
      <!-- Files -->
      <div class="sub-item-head">
        <i nz-icon nzType="icons:file" class="svg-icon mini-icon"></i>
        <span class="body-bold">{{ i18n.langString("files") }}</span>
      </div>
      <div class="sub-item-content file-wrapper">
        @for (file of item().details.files; track $index) {
          <div class="file" (click)="openFile(file)">
            <a class="link-underline black-coral-text">{{ file.filename }}</a>
            <i
              nz-icon
              nzType="icons:eye"
              class="svg-icon mini-icon history-right-icon"
            ></i>
          </div>
        }
      </div>
      <div></div>
    </div>
  }
</div>
